export default "__VITE_ASSET__db8772ed__"